import React from 'react';

// Simple Oval spinner to replace react-preloader-icon
const OvalSpinner = ({ size = 20, strokeWidth = 10, strokeColor = "#000" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 38 38"
    xmlns="http://www.w3.org/2000/svg"
    stroke={strokeColor}
  >
    <g fill="none" fillRule="evenodd">
      <g transform="translate(1 1)" strokeWidth={strokeWidth > 5 ? 4 : 2}>
        <circle strokeOpacity=".3" cx="18" cy="18" r="18" />
        <path d="M36 18c0-9.94-8.06-18-18-18">
          <animateTransform
            attributeName="transform"
            type="rotate"
            from="0 18 18"
            to="360 18 18"
            dur="1s"
            repeatCount="indefinite"
          />
        </path>
      </g>
    </g>
  </svg>
);

const LoadingLayover = ({children, loading, size = 20, strokeWidth = 10, strokeColor = "#000", ...props}) => {
  if (!loading) return children;

  return (
    <div className='loading-layover'>
      <div className='layover'>
        <div className='loading-spinner'>
          <OvalSpinner size={size} strokeWidth={strokeWidth} strokeColor={strokeColor} />
        </div>
      </div>
      {children}
    </div>
  );
}

export default LoadingLayover;
